<div
  *ngIf="!(completed$ | async)"
  class="resume-component"
  sonderMediaqueryClass="mq"
  [attr.data-running]="wizardSvc.running$ | async"
  (click)="toggleFlow()"
  id="resume-component"
>
  <span
    *ngIf="!wizardSvc.isOffModalMatchflow"
    class="resume-message"
    role="button"
    data-test="match-me-later-button"
  >
    {{ (wizardSvc.running$ | async) ? "Match Me Later" : "Resume Match" }}
  </span>
  <button
    *ngIf="!wizardSvc.isOffModalMatchflow"
    mat-fab
    class="mat-elevation-z0"
    data-test="close-button"
  >
    <mat-icon class="close-icon">close</mat-icon>
    <span class="cdk-visually-hidden">{{ (wizardSvc.running$ | async) ? 'Close' : 'Resume' }}</span>
  </button>
</div>
